var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qualification-body"},[_c('div',{staticClass:"qualification-container"},[_c('CurrentCom',{attrs:{"editDisable":_vm.editDisable}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }